import { BaseRestoreFormsModel } from 'wizards/models/base/base-restore-forms-model';
import { RestoreSourceStepValue } from 'wizards/models/restore-source-models';
import { RestoreAsDiskEnum, TypeDataStepValue } from 'wizards/models/type-data-models';
import { DestinationVMStepValue } from '../destination-vm-models';

export class RestoreHyperVFormModel extends BaseRestoreFormsModel {
  restoreSourceStep: RestoreSourceStepValue = { folders: [], valid: true };
  typeDataStep: TypeDataStepValue = {
    restoreAs: RestoreAsDiskEnum.Virtual,
    selectedFileFormat: this.fileFormats[0],
    valid: true
  };

  destinationStep: DestinationVMStepValue = {
    destinationFolder: '',
    overwriteExistingVM: false,
    powerOnVM: false,
    toOriginalLocation: false,
    valid: true
  };

  constructor(public isNBF = false) {
    super(isNBF);
  }
}
